import { render, staticRenderFns } from "./ProductItemVariantImage.vue?vue&type=template&id=5d732944&"
import script from "./ProductItemVariantImage.vue?vue&type=script&lang=js&"
export * from "./ProductItemVariantImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports